window.onload = function boldCheck() {
  let customOptions = document.getElementsByClassName('bold_options_loaded')[0]
    if(customOptions){
  }else{
    document.getElementById('AddToCart').disabled = true
    document.getElementsByClassName('no-bold')[0].style.display = 'block'
  }
}
